import React, { useEffect, useState } from 'react';
import api_config from '../../../../api_config.json';
import './Dashboard.css';

export default function Dashboard(props){
    const [dashboardStatus, setDashboardStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [updating, setUpdating] = useState(false);

    useEffect(() => {
        console.log(props.name);
        
        if (props.name === "Profit Dashboard") {
            fetchDashboardStatus();
        }
    }, [props.name]);

    const fetchDashboardStatus = async () => {
        setLoading(true);
        const env = process.env.REACT_APP_ENV || 'dev';
        const apiUrl = api_config[env]?.CHECK_OP_DASHBOARD_UPDATER_STATUS_API;
        
        try {
            if (!apiUrl) {
                setDashboardStatus({ status: 'UNAVAILABLE', message: 'Status check not available in this environment' });
                return;
            }

            const response = await fetch(apiUrl);
            const rawData = await response.json();
            
            // Parse the nested JSON body if it exists
            const data = rawData.body ? JSON.parse(rawData.body) : rawData;
            setDashboardStatus(data);
        } catch (error) {
            console.error('Error fetching dashboard status:', error);
            console.error('Error details:', error.message);
            console.error('API URL:', apiUrl);
            setDashboardStatus({ status: 'ERROR', message: 'Failed to fetch status' });
        } finally {
            setLoading(false);
        }
    };

    const triggerUpdate = async () => {
        setUpdating(true);
        const env = process.env.REACT_APP_ENV || 'dev';
        const apiUrl = api_config[env]?.CHECK_OP_DASHBOARD_UPDATER_STATUS_API;
        
        try {
            if (!apiUrl) {
                console.error('Update API not available in this environment');
                return;
            }

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            const rawData = await response.json();
            const data = rawData.body ? JSON.parse(rawData.body) : rawData;
            
            console.log('Update triggered:', data);
            
            // Immediately refresh the status to show IN_PROGRESS
            await fetchDashboardStatus();
            
        } catch (error) {
            console.error('Error triggering update:', error);
            console.error('Error details:', error.message);
            console.error('API URL:', apiUrl);
        } finally {
            setUpdating(false);
        }
    };

    const renderStatusText = () => {
        if (loading) {
            return <p style={{ color: '#666', fontSize: '14px', margin: '0' }}>Loading status...</p>;
        }

        if (!dashboardStatus) return null;

        const { status, message, lastUpdated, startTime } = dashboardStatus;
        
        switch (status) {
            case 'IN_PROGRESS':
                return (
                    <p style={{ color: '#ff9800', fontSize: '14px', margin: '0' }}>
                        {message} (Started: {new Date(startTime).toLocaleString('en-GB')})
                    </p>
                );
            case 'COMPLETED':
                return (
                    <p style={{ color: '#4caf50', fontSize: '14px', margin: '0' }}>
                        Last updated: {new Date(lastUpdated).toLocaleString('en-GB')}
                    </p>
                );
            case 'UNAVAILABLE':
                return (
                    <p style={{ color: '#666', fontSize: '14px', margin: '0' }}>
                        {message}
                    </p>
                );
            case 'ERROR':
                return (
                    <p style={{ color: '#f44336', fontSize: '14px', margin: '0' }}>
                        {message}
                    </p>
                );
            default:
                return (
                    <p style={{ color: '#666', fontSize: '14px', margin: '0' }}>
                        {message || 'Status unknown'}
                    </p>
                );
        }
    };

    return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'stretch', alignItems: 'center', height: '82vh'}}>
            <div className='account-recs--intro'>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <h1 className='dashboard-title'>{props.name}</h1>
                    {props.name === "Profit Dashboard" && (
                        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                            {renderStatusText()}
                            <button 
                                onClick={triggerUpdate}
                                disabled={updating || dashboardStatus?.status === 'IN_PROGRESS'}
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    backgroundColor: (updating || dashboardStatus?.status === 'IN_PROGRESS') ? '#ccc' : '#4caf50',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    cursor: (updating || dashboardStatus?.status === 'IN_PROGRESS') ? 'not-allowed' : 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                title={updating ? 'Updating...' : dashboardStatus?.status === 'IN_PROGRESS' ? 'Update in progress' : 'Trigger Update'}
                            >
                                ↻
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <div className='account-recs'>
                    <iframe
                        src={props.link}
                        width="100%"
                        style={{borderRadius: '16px'}}
                        height="100%"
                        >
                    </iframe>
            </div>
        </div>
    );
}